import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ModalData } from '@purespectrum1/ui/modal';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'ps-ui-psid-view-modal',
  templateUrl: './psid-view-modal.component.html',
  styleUrls: ['./psid-view-modal.component.css'],
})
export class PsidViewModalComponent implements OnInit, OnDestroy {
  psidList: string[] = this._modalData;
  constructor(
    @Inject(ModalData) private _modalData: string[],
    @Inject(DOCUMENT) private _document: Document,
    private _renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this._renderer.addClass(this._document.body, 'modal-open');
  }
  ngOnDestroy() {
    this._renderer.removeClass(this._document.body, 'modal-open');
  }
}
